export const APP_NAME = 'Norma';
export const APP_NAME_UPPER = APP_NAME.toUpperCase();
export const contactEmail = 'contact@norma.software';
// export const calendlyLink = 'https://calendly.com/clara-norma';
export const conditionsLink = 'https://www.norma.software/cgau';
